import { render, staticRenderFns } from "./ProductBasicInfo.vue?vue&type=template&id=1046ae9c&"
import script from "./ProductBasicInfo.vue?vue&type=script&lang=js&"
export * from "./ProductBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports